import React from 'react';
import {
  Box, Typography, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Grid,
} from '@mui/material';

export default function CashFlow() {
  return (
    <Box>
      <Typography variant="h4" fontWeight="bold" gutterBottom>Flujo de Caja</Typography>
      <Typography variant="body1" color="textSecondary" gutterBottom>
        Vision mensual de ingresos y gastos previstos vs reales por proyecto.
      </Typography>

      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2, textAlign: 'center' }}>
            <Typography variant="body2" color="textSecondary">Ingresos Previstos</Typography>
            <Typography variant="h5" color="success.main">0.00 EUR</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2, textAlign: 'center' }}>
            <Typography variant="body2" color="textSecondary">Gastos Previstos</Typography>
            <Typography variant="h5" color="error.main">0.00 EUR</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2, textAlign: 'center' }}>
            <Typography variant="body2" color="textSecondary">Balance</Typography>
            <Typography variant="h5">0.00 EUR</Typography>
          </Paper>
        </Grid>
      </Grid>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Periodo</TableCell>
              <TableCell align="right">Ingresos Prev.</TableCell>
              <TableCell align="right">Gastos Prev.</TableCell>
              <TableCell align="right">Ingresos Reales</TableCell>
              <TableCell align="right">Gastos Reales</TableCell>
              <TableCell align="right">Balance</TableCell>
              <TableCell align="right">Acumulado</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell colSpan={7} align="center">
                <Typography color="textSecondary">Selecciona un proyecto para ver su flujo de caja</Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
